import * as React from "react";
import { createRoot } from "react-dom/client";
import "./styles/index.css";
import App from "./components/App";

/* global document, Office, module, require */

const rootElement = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

Office.onReady((info) => {
  if (info.host === Office.HostType.Excel) {
    root?.render(<App />);
  }
});

if (module.hot) {
  module.hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(<NextApp />);
  });
}
